import { Maybe } from '@/utils/types'
import { ContentItemType } from '../types'
import { ContentInteraction } from '../useContentInteraction'

type Surface = 'discover'

/**
 * Interaction builder for items in discover / watch landing view
 * Used for tracking user interactions with content in collections and carousels
 */
export class DiscoverItemInteraction extends ContentInteraction<Surface> {
  constructor(item: { id: string; __typename: Maybe<ContentItemType>; attribution: unknown }) {
    super(item)
  }
}
